module.exports = __webpack_public_path__ + "img/CV.Drainage.Drainage_trench.Concrete_pipe.b0967404.png";